export namespace StringUtil {
  export function trimNotNecessarySpaces(term: string): string {
    if (!term) {
      return null;
    }
    term = trimStart(term);
    term = trimEnd(term);
    term = trimMoreThanOneSpace(term);
    return term;
  }

  export function trimStart(term: string): string {
    if (!term) {
      return null;
    }
    return term.replace(/^\s*/, '');
  }

  export function trimEnd(term: string): string {
    if (!term) {
      return null;
    }

    return term.replace(/\s*$/, '');
  }

  export function trimMoreThanOneSpace(term: string): string {
    if (!term) {
      return null;
    }

    return term.replace(/\s\s+/g, ' ');
  }

  export function trimMultipleSpaces(term: string): string {
    if (!term) {
      return null;
    }

    return term.replace(/\s\s+/g, '');
  }
}
